import React from 'react';
import PropTypes from 'prop-types';
import AuthContext from "../../../contexts/authContext";
import DealerUserProfileContext from "../../../contexts/dealerUserProfileContext";
import LoadingDialog from "../../atoms/LoadingDialog";
import TermsAndConditionsModal from '../../molecules/TermsAndConditionsModal';
import {useMutation} from "@apollo/client";
import {gql} from "@apollo/client";

const LoginProviderFactory = React.lazy(() => import( "../../organisms/LoginProviderFactory"))
const FlexiTemplate = React.lazy(() => import( "../FlexiTemplate"))
const DealerUserProfileProvider = React.lazy(() => import( "../../organisms/DealerUserProfileProvider"))
const DealershipSelectionProvider = React.lazy(() => import( "../../organisms/DealershipSelectionProvider"))
const DealerAppBar = React.lazy(() => import( '../../molecules/DealerAppBar'))

const UPDATE_CUSTOMER_ATTRIBUTE = gql`
    mutation UPDATE_CUSTOMER_ATTRIBUTE($key: String!, $value: String!) {
        userProfileUpdate(
            attributes: {key: $key, value: $value}
        ) {
            ok
            result {
                id
                attribute(key: $key)
            }
            errors {
                messages
                field
            }
        }
    }
`
const currentAgreementDate = "2025-16-06"

const TemplateConfigurator = ({children}) => {
    const {logout: onLogout} = React.useContext(AuthContext);
    const user = React.useContext(DealerUserProfileContext);
    const [showTCModal, setShowTCModal] = React.useState(false);

    const [updateCustomerAttribute] = useMutation(
        UPDATE_CUSTOMER_ATTRIBUTE, {
            refetchQueries: [
                'GET_USER_PROFILE_QUERY'
            ],
        });

    React.useEffect(() => {
        console.log({user});
        if (user?.loading) {
            return;
        }

        const agreedAt = user?.hasAgreedTCs
        if (agreedAt !== currentAgreementDate) {
            setShowTCModal(true);
        }
    }, [user]);

    const handleTCContinue = async () => {
        return new Promise((resolve, reject) => {
            updateCustomerAttribute({
                variables: {
                    key: "hasAgreedTCs",
                    value: currentAgreementDate,
                },
            }).then(({data}) => {
                if (data?.userProfileUpdate?.ok) {
                    setShowTCModal(false);
                    resolve(data);
                } else {
                    console.error({error: data})
                    reject("Unexpected error")
                }
            })
                .catch((error) => {
                    console.error({error});
                    reject("Unexpected error");
                });
        })
    }

    return (
        <FlexiTemplate onLogout={onLogout} user={user}>
            <DealerAppBar
                user={user}
                onLogout={onLogout}
            />
            {showTCModal ? (
                <TermsAndConditionsModal open onContinue={handleTCContinue}/>
            ) : children}
        </FlexiTemplate>
    )
}
TemplateConfigurator.propTypes = {
    children: PropTypes.node,
}

const LoggedInFlexiTemplate = ({
                                   method, endpoint, children, test = false
                               }) => {
    return (
        <React.Suspense fallback={<LoadingDialog/>}>
            <LoginProviderFactory method={method} endpoint={endpoint}>
                <DealerUserProfileProvider>
                    <DealershipSelectionProvider test={test}>
                        <TemplateConfigurator>{children}</TemplateConfigurator>
                    </DealershipSelectionProvider>
                </DealerUserProfileProvider>
            </LoginProviderFactory>
        </React.Suspense>
    )

}
LoggedInFlexiTemplate.propTypes = {
    chidren: PropTypes.node
}


export default LoggedInFlexiTemplate
export {LoggedInFlexiTemplate}